import { render, staticRenderFns } from "./ViewCommunicationComponent.vue?vue&type=template&id=79328514"
import script from "./ViewCommunicationComponent.vue?vue&type=script&lang=js"
export * from "./ViewCommunicationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports